import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { isEmpty } from "lodash";
import classNames from "classnames";
import { segmentEventTracker } from "../../../../utils/SegmentEventTracker";
import {PageViewName, TrackEventName} from "../../../shared/constants/SegmentEvents";

import {
  fetchCompany,
  fetchDataPoint,
} from "../../../company/actions";
import { updateBusinessTrustpass } from "../../businessTrustpassActions";

import Layout from "../../../shared/components/layouts/MainLayout";
import BusinessTrustpassInformationForm from "../../components/business/InformationForm";

export class BusinessTrustpassInformationContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      business_trustpass: this.setBusinessTrustpassDefaultState(),
      submitting: false,
      errors: {},
    };

    this.onSave = this.onSave.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  componentWillMount() {
    this.trackPageView();
    this.props.fetchCompany();
    this.props.fetchDataPoint('numberofe1');
    this.props.fetchDataPoint('AAindustr1');
    this.props.fetchDataPoint('subindust1');
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.business_trustpass.id && this.props.business_trustpass.id) {
      this.setState({
        business_trustpass: this.setBusinessTrustpassDefaultState(),
      });
    }

    if (prevProps.company !== this.props.company) {
      this.setState({
        business_trustpass: this.setBusinessTrustpassDefaultState(),
      });
    }
  }

  setBusinessTrustpassDefaultState() {
    if (Object.keys(this.props.business_trustpass).length > 0) {
      return {
        ...this.props.business_trustpass,
        number_of_employees: this.props.company.number_of_employees,
        industry: this.props.company.industry,
        sub_industry: this.props.company.sub_industry,
      };
    }

    return {
      company_name: this.props.company.company_name,
      company_type: this.props.company.company_type,
      company_contact_number: this.props.company.phone,
      company_address: this.props.company.full_address,
    };
  }

  onBack = () => {
    segmentEventTracker.trackEvent(TrackEventName.BACK_CLICKED);
    this.props.push('/requirements');
  }

  getDataPointOptionUID = (type, value) => {
    const dataPoint = this.props.dataPoints[type]
    if (!dataPoint) return;

    return dataPoint.data_point_options.find((option) => {
      return option.text === value;
    }).uid;
  }

  dataPointPayload = (type, value) => {
    const dataPoint = this.props.dataPoints[type];
    const uid = this.getDataPointOptionUID(type, value);
    if (isEmpty(dataPoint)) return;

    let dataPointValue = dataPoint.data_point_options
      .find((item) => { return item.uid === uid; })

    return {
      data_point_id: dataPoint.id,
      value: dataPointValue.text,
      type: "TextDataPointValue",
      data_point_option_uid: dataPointValue.uid,
    }
  }

  payload = () => {
    return {
      ...this.state.business_trustpass,
      lead_attributes: {
        data_point_values_attributes: [
          this.dataPointPayload("numberofe1", this.state.business_trustpass.number_of_employees),
          this.dataPointPayload("AAindustr1", this.state.business_trustpass.industry),
          this.dataPointPayload("subindust1", this.state.business_trustpass.sub_industry),
        ]
      }
    };
  }

  submit() {
    const onSuccess = () => {
      this.setState({ errors: {}, submitting: false }, () => {
        this.props.push('/requirements');
      })
    };
    const onError = (errors) => {
      this.setState({ submitting: false, errors });
    };

    this.props.updateBusinessTrustpass(
      {
        userId: this.props.user.id,
        businessTrustpassId: this.props.business_trustpass.id,
      },
      this.payload(),
      onSuccess,
      onError,
    );
  }

  onSave() {
    segmentEventTracker.trackEvent(TrackEventName.BUSINESS_INFO_SUBMIT_FORM_CLICKED);
    this.setState({submitting: true});
    this.submit();
  }

  onChangeValue(field) {
    return (e) => {
      const value = e.target.value;
      const new_business_trustpass = Object.assign(
        {},
        this.state.business_trustpass,
        {[field]: value}
      );
      this.setState({business_trustpass: new_business_trustpass});

      if(e.target.name === 'industry') {
        this.setState({business_trustpass: { ...new_business_trustpass, sub_industry: '' }})
      }
    }
  }

  onFocus(e) {
    const name = e.target.name;

    switch (name) {
      case 'company_type':
        segmentEventTracker.trackEvent(TrackEventName.COMPANY_TYPE_CLICKED);
        break;
      case 'number_of_employees':
        segmentEventTracker.trackEvent(TrackEventName.NUMBER_OF_EMPLOYEES_CLICKED);
        break;
      case 'industry':
        segmentEventTracker.trackEvent(TrackEventName.INDUSTRY_CLICKED);
        break;
      case 'sub_industry':
        segmentEventTracker.trackEvent(TrackEventName.SUB_INDUSTRY_CLICKED);
        break;
      default:
        return null;
    }
  }

  isFormDisabled() {
    if (!this.props.business_trustpass) return false;

    const status = this.props.business_trustpass.information_status;
    return status === "rejected" || status === "verified";
  }

  isSaveDisabled() {
    const information = this.state.business_trustpass;
    return !(
      information.company_name &&
      information.company_type &&
      information.year_of_registration &&
      information.company_contact_number &&
      information.company_address &&
      information.number_of_employees &&
      information.industry &&
      information.sub_industry
    );
  }

  buttonClassnames() {
    return classNames(
      "ds-btn",
      "--medium",
      "--full",
      {"_loading": this.state.submitting},
    );
  }

  trackPageView() {
    segmentEventTracker.trackPageView(PageViewName.ONBOARDING_BUSINESS_INFO_VIEWED)
  }

  render() {
    return (
      <Layout
        header="Complete Your Business Information"
        backButtonAction={this.onBack}
        gridClassName="--narrow"
      >
        <div className="ds-card _tight">
          <section className="cardSection">
            <h2 className="subhead">
              Business Information
            </h2>
          </section>

          <BusinessTrustpassInformationForm
            information={this.state.business_trustpass}
            dataPoints={this.props.dataPoints}
            errors={this.state.errors}
            disabled={this.isFormDisabled()}
            onChangeValue={this.onChangeValue}
            submitting={this.state.submitting}
            onSave={this.onSave}
            onFocus={this.onFocus}
          />
          <button
            className={this.buttonClassnames()}
            disabled={this.isSaveDisabled()}
            onClick={this.onSave}
            data-test='business-info-submit-form'
          >
            Submit Your Business Information
          </button>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataPoints: state.dataPoints,
    user: state.user,
    company: state.company,
    business_trustpass: state.business_trustpass,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    updateBusinessTrustpass: (urlProps, body, onSuccess, onError) => {
      dispatch(updateBusinessTrustpass(urlProps, body, onSuccess, onError));
    },
    push:           (url) => dispatch(push(url)),
    fetchCompany:   () => dispatch(fetchCompany()),
    fetchDataPoint: (type) => dispatch(fetchDataPoint(type)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessTrustpassInformationContainer);



// WEBPACK FOOTER //
// ./src/features/trustpass/containers/business/InformationContainer.js